import * as EventEmitter from 'eventemitter3';

/**
 * Wrapper of EventEmitter. This class only overwrites the `emit`
 * function to emit a `catch-all` event.
 */
export class EventEmitterBase extends EventEmitter {
    emit(event, ...args: Array<any>): boolean {
        if (event != 'event') {
            this.emit('event', {
                sourceEvent: {
                    type: event,
                    args: args,
                },
            });
        }
        return super.emit(event, ...args);
    }
}
